import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 14,
    type: CHECKLIST_ITEM_TYPE.SEND_TREATMENT_PLAN,
    manifestKey: 'SEND_TREATMENT_PLAN',

    try_it: {
        button_label: 'Send Treatment Plan',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'SendTreatmentPlanCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { scheduled_message_id: 'demo-msg-001' },
        },
    },
    pre_flight_diff: [
        'Step 1: POST /leads/{lead_pk}/share-treatment-plan/ — queues treatment plan email',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'automation_message_sent signal logs to lead timeline',
        'Treatment plan email sent to lead\'s email address',
        'Role gate: ADMIN or TCO only — USER role returns 403',
        'Lead must have email and at least one lead_treatment',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
